
import { Button, Card, CardContent, CardHeader } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../app/store";
import { showModalContributeCapitalAction } from "./capital-contribute.slice";
import AddCapitalModal from "./components/AddCapitalModal";
import LoadingIndicator from "../../app/components/loading-indicator";
import CapitalContributeFilter from "./components/capital-contribute-filter";
import CapitalContributeTable from "./components/capital-contribute-table";

export default function CapitalContribute() {

  const dispatch = useAppDispatch()
  const { history, loading } = useAppSelector((state: RootState) => state.capitalContribute)

  const showModalAddCapital = () => dispatch(showModalContributeCapitalAction(true))

  return (
    <>  
      <LoadingIndicator open={loading} />
      <AddCapitalModal />
      <CapitalContributeFilter />
      <Card>
        <CardHeader
          title="Aporte Capital"
          action={<Button variant="contained" onClick={showModalAddCapital}> Añadir </Button>}
        />
        <CardContent>
          <CapitalContributeTable history={history} />
        </CardContent>
      </Card>
    </>
  )
}